import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useSelector } from 'react-redux';

const SOCKET_URL = process.env.REACT_APP_SOCKET;

const SocketContext = createContext(null);

export const useSocket = () => {
    return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
    const user = useSelector((state) => state.user);
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        if (!user?.id) return;

        const s = io(SOCKET_URL, {
            query: { userId: user.id },
            transports: ['websocket'],
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            reconnectionAttempts: Infinity,
            forceNew: false,
        });

        setSocket(s);

        // Debugging
        s.on('connect', () => {
            console.log('🔌 Conectado al socket:', s.id);
        });

        s.on('disconnect', () => {
            console.log('❌ Desconectado del socket');
        });

        return () => {
            s.disconnect();
            setSocket(null);
        };
    }, [user?.id]);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};
